var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmallRight = function SvgArrowSmallRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowSmallRight_svg__arrow-small-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ArrowSmallRight_svg__Vector (Stroke)",
    d: "M12.1517 9.60531C12.352 9.85079 12.3374 10.2131 12.1086 10.4419L8.77523 13.7752C8.53115 14.0193 8.13552 14.0193 7.89144 13.7752C7.64736 13.5311 7.64736 13.1355 7.89144 12.8914L10.7829 10L7.89144 7.10856C7.64736 6.86448 7.64736 6.46885 7.89144 6.22477C8.13552 5.98069 8.53115 5.98069 8.77523 6.22477L12.1086 9.55811L12.1517 9.60531Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowSmallRight;